(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["backup-video-modal"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoModal = document.querySelector('.video-modal');
  const videoModalTriggers = document.querySelectorAll('.js-video-modal-trigger');
  const videoModalClose = videoModal ? videoModal.querySelector('.js-video-modal-close') : null;
  const videoContainer = videoModal ? videoModal.querySelector('.video-modal__video-container') : null;

  function openModal(videoUrl) {
    if (!videoModal || !videoContainer) return;

    let embedUrl = '';
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] || videoUrl.split('/').pop();
      embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    } else if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.split('/').pop();
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }

    if (embedUrl) {
      videoContainer.innerHTML = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      videoModal.style.display = 'flex';
    }
  }

  function closeModal() {
    if (videoContainer) videoContainer.innerHTML = '';
    if (videoModal) videoModal.style.display = 'none';
  }

  if (videoModalTriggers.length) {
    videoModalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const videoUrl = this.dataset.videoUrl;
        if (videoUrl) {
          openModal(videoUrl);
        }
      });
    });
  }

  if (videoModalClose) {
    videoModalClose.addEventListener('click', closeModal);
  }

  if (videoModal) {
    videoModal.addEventListener('click', function(e) {
      if (e.target === videoModal) {
        closeModal();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-2-col-layout"] && !Shopify.designMode) return;
  try {
    
  const assessmentRevealSections = document.querySelectorAll('[data-assessment-reveal-root]');

  if (assessmentRevealSections.length > 0) {
    const assessmentRevealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.25 });

    assessmentRevealSections.forEach((section) => assessmentRevealObserver.observe(section));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-testimonial"] && !Shopify.designMode) return;
  try {
    
  const storyRevealItems = document.querySelectorAll('[data-story-reveal]');

  if (storyRevealItems.length > 0) {
    const storyRevealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.22 });

    storyRevealItems.forEach((item) => storyRevealObserver.observe(item));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-arrow-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-list-reveal]');
    if (!sections.length) return;

    const reveal = (section) => section.classList.add('is-visible');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.25 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-feature-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-feature-grid-reveal]');
    if (!sections.length) return;

    const reveal = (section) => {
      section.style.setProperty('--feature-count', section.querySelectorAll('.feature-grid__item').length);
      section.classList.add('is-visible');
    };

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.22 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-grid-layout"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.querySelector('.content-modal');
  const modalTriggers = document.querySelectorAll('.js-content-modal-trigger');
  const modalClose = document.querySelector('.js-content-modal-close');
  const modalBody = document.querySelector('.content-modal__body-container');

  function openModal(contentId) {
    const contentElement = document.getElementById(contentId);
    if (modalBody && contentElement) {
      modalBody.innerHTML = contentElement.innerHTML;
      modal.style.display = 'flex';
    }
  }

  function closeModal() {
    if (modalBody) modalBody.innerHTML = '';
    if (modal) modal.style.display = 'none';
  }

  if (modalTriggers.length > 0) {
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const contentId = this.dataset.modalContentId;
        openModal(contentId);
      });
    });
  }

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-list-section-horizontal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-outcomes-reveal]');
    if (!sections.length) return;

    const reveal = (section) => section.classList.add('is-visible');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.25 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-minimal-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const walls = document.querySelectorAll('[data-testimonial-proof-wall]');
    if (!walls.length) return;

    const reveal = (wall) => wall.classList.add('is-visible');

    if (!('IntersectionObserver' in window)) {
      walls.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.18 });

    walls.forEach((wall) => observer.observe(wall));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonial-video-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoModal = document.querySelector('.video-modal');
  const videoModalTriggers = document.querySelectorAll('.js-video-modal-trigger');
  const videoModalClose = document.querySelector('.js-video-modal-close');
  const videoContainer = document.querySelector('.video-modal__video-container');

  function openModal(videoUrl) {
    if (!videoContainer || !videoUrl) return;
    videoContainer.innerHTML = ''; // Clear previous content

    let videoElement = '';

    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] || videoUrl.split('/').pop();
      const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      videoElement = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.split('/').pop();
      const embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      videoElement = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoUrl.toLowerCase().endsWith('.mp4')) {
      videoElement = `<video src="${videoUrl}" controls autoplay playsinline loop style="width:100%; height:100%;"></video>`;
    }

    if (videoElement) {
      videoContainer.innerHTML = videoElement;
      videoModal.style.display = 'flex';
      const videoTag = videoContainer.querySelector('video');
      if (videoTag) {
        videoTag.play().catch(error => {
          console.log("Autoplay was prevented by browser policy: ", error);
        });
      }
    }
  }

  function closeModal() {
    if (videoContainer) {
      const videoTag = videoContainer.querySelector('video');
      if (videoTag) {
        videoTag.pause();
        videoTag.src = '';
      }
      videoContainer.innerHTML = '';
    }
    if (videoModal) {
      videoModal.style.display = 'none';
    }
  }

  if (videoModalTriggers.length) {
    videoModalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const videoUrl = this.dataset.videoUrl;
        openModal(videoUrl);
      });
    });
  }

  if (videoModalClose) {
    videoModalClose.addEventListener('click', closeModal);
  }

  if (videoModal) {
    videoModal.addEventListener('click', function(e) {
      if (e.target === videoModal) {
        closeModal();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-chair-modal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoModal = document.querySelector('.video-modal');
  const videoModalTriggers = document.querySelectorAll('.js-video-modal-trigger');
  const videoModalClose = document.querySelector('.js-video-modal-close');
  const videoContainer = document.querySelector('.video-modal__video-container');

  function openModal(videoUrl) {
    if (!videoContainer || !videoUrl) return;
    videoContainer.innerHTML = '';

    let videoElement = '';

    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] || videoUrl.split('/').pop();
      const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
      videoElement = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.split('/').pop();
      const embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      videoElement = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    } else if (videoUrl.toLowerCase().endsWith('.mp4')) {
      videoElement = `<video src="${videoUrl}" controls autoplay playsinline loop style="width:100%; height:100%;"></video>`;
    }

    if (videoElement) {
      videoContainer.innerHTML = videoElement;
      videoModal.style.display = 'flex';
      const videoTag = videoContainer.querySelector('video');
      if (videoTag) {
        videoTag.play().catch(error => {
          console.log("Autoplay was prevented by browser policy: ", error);
        });
      }
    }
  }

  function closeModal() {
    if (videoContainer) {
      const videoTag = videoContainer.querySelector('video');
      if (videoTag) {
        videoTag.pause();
        videoTag.src = '';
      }
      const iframeTag = videoContainer.querySelector('iframe');
      if (iframeTag) {
        iframeTag.src = '';
      }
      videoContainer.innerHTML = '';
    }
    if (videoModal) {
      videoModal.style.display = 'none';
    }
  }

  if (videoModalTriggers.length) {
    videoModalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const videoUrl = this.dataset.videoUrl;
        if (videoUrl) {
          openModal(videoUrl);
        }
      });
    });
  }

  if (videoModalClose) {
    videoModalClose.addEventListener('click', closeModal);
  }

  if (videoModal) {
    videoModal.addEventListener('click', function(e) {
      if (e.target === videoModal) {
        closeModal();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoModal = document.querySelector('.video-modal');
  const videoModalTriggers = document.querySelectorAll('.js-video-modal-trigger');
  const videoModalClose = document.querySelector('.js-video-modal-close');
  const videoContainer = document.querySelector('.video-modal__video-container');

  function openModal(videoUrl) {
    let embedUrl = '';
    if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
      const videoId = videoUrl.split('v=')[1]?.split('&')[0] || videoUrl.split('/').pop();
      embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    } else if (videoUrl.includes('vimeo.com')) {
      const videoId = videoUrl.split('/').pop();
      embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }

    if (embedUrl && videoContainer) {
      videoContainer.innerHTML = `<iframe src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      videoModal.style.display = 'flex';
    }
  }

  function closeModal() {
    if (videoContainer) videoContainer.innerHTML = '';
    if (videoModal) videoModal.style.display = 'none';
  }

  if (videoModalTriggers.length) {
    videoModalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const videoUrl = this.dataset.videoUrl;
        if (videoUrl) {
          openModal(videoUrl);
        }
      });
    });
  }

  if (videoModalClose) {
    videoModalClose.addEventListener('click', closeModal);
  }

  if (videoModal) {
    videoModal.addEventListener('click', function(e) {
      if (e.target === videoModal) {
        closeModal();
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-rise-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-testimonial-rise]');
    if (!sections.length) return;

    const reveal = (section) => section.classList.add('is-visible');

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();
})();
